module.exports = __webpack_public_path__ + "static/img/2253_phase_function_Paper_PointsHejduk_Prediction.4e85912.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2253_phase_function_Paper_PointsHejduk_Prediction.png
// module id = Zmr2
// module chunks = 0